const NoResult = ({ ...props }) => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="Union"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.2932 29.707L21.4562 22.871C19.1832 24.821 16.2282 26 13.0002 26C5.82524 26 0.000244141 20.175 0.000244141 13C0.000244141 5.825 5.82524 0 13.0002 0C20.1752 0 26.0002 5.825 26.0002 13C26.0002 16.228 24.8212 19.183 22.8712 21.456L29.7072 28.293C30.0972 28.683 30.0972 29.317 29.7072 29.707C29.3172 30.097 28.6832 30.097 28.2932 29.707ZM24.0002 13C24.0002 6.929 19.0712 2 13.0002 2C6.92924 2 2.00024 6.929 2.00024 13C2.00024 19.071 6.92924 24 13.0002 24C19.0712 24 24.0002 19.071 24.0002 13ZM9.46431 8.05001L13.0003 11.586L16.5363 8.05001C16.9263 7.66001 17.5593 7.66001 17.9503 8.05001C18.3403 8.44101 18.3403 9.07401 17.9503 9.46401L14.4143 13L17.9503 16.536C18.3403 16.926 18.3403 17.559 17.9503 17.95C17.5593 18.34 16.9263 18.34 16.5363 17.95L13.0003 14.414L9.46431 17.95C9.07431 18.34 8.44131 18.34 8.05031 17.95C7.66031 17.559 7.66031 16.926 8.05031 16.536L11.5863 13L8.05031 9.46401C7.66031 9.07401 7.66031 8.44101 8.05031 8.05001C8.44131 7.66001 9.07431 7.66001 9.46431 8.05001Z"
                fill="#1F1E1F"
            />
        </svg>
    )
}

export default NoResult
